import { PlusCircle, ThreeDotsVertical } from "react-bootstrap-icons";
import { Column } from "../../Components/Tables/Table";
import { useNavigate, useParams } from "react-router-dom";
import { header } from "../../Shared/Cards/Card.type";
import { prepareSearchColumns } from "../../Utility/Utility";
import { Client } from "./model/Client.type";
import { changeStatus, deleteClient } from "./service/client.service";
import { ApiResponse } from "../../model/common/apiResponse";
import { useEffect, useState } from "react";
import useClientStore from "../../store/client/useClientStore";
import toast from "react-hot-toast";
import CommonConfirmationModal from "../../Components/Modals/CommonConfirmationModal";
import SetupList from "../setup/list/List";
import useUserStore, { userAccess } from "../../store/auth/userStore";

export default function ClientOverview() {
  const navigation = useNavigate();
  const { viewtype } = useParams<{ viewtype: string }>();
  const [statusData, setStatusData] = useState<any>();
  const [data, setData] = useState<any>(null);
  const [userAccess, setUserAccess] = useState<userAccess | null>(null);
  const { currentUser, fetchUser } = useUserStore();
  const [loading, setLoading] = useState(true);
  const [confirmModalData, setConfirmModalData] = useState({
    client_id: 0,
    showconfModal: false,
    message: ''
  });
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const handleconfShow = () => {
    setConfirmModalData((prevData) => ({
      ...prevData,
      showconfModal: true
    }));
  };
  const handleconfClose = () => {
    setConfirmModalData({
      client_id: 0,
      showconfModal: false,
      message: ``
    });
  }
  const pageName = "Clients";
  const addUrl = "/account/client/overview/create"
  const listUrl = "/account/client/overview/list-view"
  const gridUrl = "/account/client/overview/grid-view"
  const ListingEndpoint = "clients/query";
  const handelEditAction = (data: any) => {
    navigation(`/account/client/overview/edit/${data.id}`)
  };
  const { fetchClient } = useClientStore();
  useEffect(() => {
    if (data) {
      fetchClient(true);
      setLoading(true);
      fetchUser().then((user: userAccess | null) => {
        setUserAccess(user);
      }).then(() => {
        setLoading(false);
      })
    }
  }, [data, fetchUser])

  const handleRowClick = (id: any) => {
    navigation(`/account/client/overview/details/${id}`);
  };

  const handelDeleteAction = (data: Client) => {
    setConfirmModalData({
      client_id: data.id,
      showconfModal: true,
      message: `Are you sure you want to delete client '${data.name}'?`
    });
  };
  const onModalSubmit = (isAccept: boolean) => {
    if (confirmModalData.client_id !== 0 && isAccept) {
      deleteClient(confirmModalData.client_id).then((response: ApiResponse<any>) => {
        if (response.status == 200) {
          toast.success("Client deleted successfully");
          setRefreshTrigger(prev => prev + 1);
        } else {
          toast.error("Failed to delete client");
        }
      });
    }
    handleconfClose();
  };
  let columns: Column[]
  if (viewtype === "list-view") {
    columns = [
      {
        name: "Client Name",
        selector: (row: Client) => (
          <span className="cursor-pointer text-primary" onClick={() => handleRowClick(row?.id)}>
            {row.name ? row.name : '-'}
          </span>
        ),
      },
      {
        name: "Warehouse ",
        selector: (row: Client) => '-',
      },
      {
        name: "City",
        selector: (row: Client) => row.city ? row.city : '-',
      },
      {
        name: "State",
        selector: (row: Client) => row.state_province ? row.state_province : '-',
      },
      {
        name: "Status",
        selector: (row: Client) => {
          return row.is_active == 1 ? (
            <span className="badge text-bg-light border border-2 px-3 border-info-subtle">
              Active
            </span>
          ) : (
            <span className="badge text-bg-light border border-2 px-3 border-danger-subtle">
              Inactive
            </span>
          );
        },
      },
      {
        name: <></>,
        selector: (row: any) => (
          <>
            <span
              className="cursor-pointer dropdown-toggle action-menu"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <ThreeDotsVertical />
            </span>
            <ul className="dropdown-menu action-items">
              <li
                className="cursor-pointer ms-3 mb-1"
                onClick={() => handelEditAction(row)}
              >
                Edit
              </li>
              <li
                className="cursor-pointer ms-3 mb-1"
                onClick={() => handelInactiveAction(row, !row.is_active)}
              >
                {row.is_active ? 'Inactive' : 'Active'}
              </li>
              {
                userAccess && userAccess?.is_spherewms_admin ? (
                  <li
                    className="cursor-pointer ms-3 mb-1"
                    onClick={() => handelDeleteAction(row)}
                  >
                    Delete
                  </li>
                ) : (
                  <></>
                )
              }
            </ul>
          </>
        ),
      },
    ];
  } else {
    columns = [
      {
        name: "",
        selector: (row: Client) => <img alt='Client Logo' src={(row.logo_url) ? row.logo_url : require('../../assets/images/noimage.png')} className="img-fluid" />,
      },
    ];
  }

  const headers: header[] = [
    {
      name: "Client Name",
      selector: (row: Client) =>
        row.name + "(" + row.code + ")",
    },
  ];
  const db_columns = [
    {
      "data": "client.id"
    },
    {
      "data": "client.code"
    },
    {
      "data": "client.name"
    },
    {
      "data": "client.city"
    },
    {
      "data": "client.state_province"
    },
    {
      "data": "logo_url"
    }
    ,
    {
      "data": "client.is_active"
    }
  ]
  const exclude_columns = ["logo_url", "client.is_active"];
  const search_columns = prepareSearchColumns(db_columns, exclude_columns);
  const getDetails = (item: any) => {
    navigation(`/account/client/overview/details/${item.id}`);
  };
  const sorting_order = [
    {
      column: "client.id",
      dir: "desc",
    },
  ];
  const handelInactiveAction = (data: any, isActive: boolean) => {
    const payload = {
      "is_active": isActive
    }
    changeStatus(`clients/${data.id}`, payload).then((response: ApiResponse<any>) => {

      if (response.status == 200) {
        setStatusData(response.data);
        toast.success('Client status updated successfully! ', {
          duration: 5000,
        });
      } else {
        toast.error('Failed to update client status!', {
          duration: 5000,
        });
      }


    })
  };

  const handleDataChange = (data: any) => {
    setData(data);
  };

  return (
    <>
      <SetupList
        pageName={pageName}
        columns={columns}
        addUrl={addUrl}
        listUrl={listUrl}
        gridUrl={gridUrl}
        viewtype={viewtype || "grid-view"}
        headers={headers}
        getDetails={getDetails}
        search_columns={search_columns}
        db_columns={db_columns}
        update_status_url={'clients'}
        statusData={statusData}
        setStatusData={setStatusData}
        onDataChange={handleDataChange}
        data={data}
        refreshTrigger={refreshTrigger}
        handelEditAction={handelEditAction}
        listEndpoint={ListingEndpoint}
        sorting_order={sorting_order}
        cardType="image"
      />
      <CommonConfirmationModal
        customClassName="header-border"
        show={confirmModalData.showconfModal}
        confirmBtnText="YES"
        cancelBtnText="NO"
        content={<> {confirmModalData.message} </>}
        onModalSubmit={onModalSubmit}
      />
    </>
  )
}
